/* eslint-disable react/jsx-no-literals */
// Shared DatePicker styles component
export const DatePickerStyles = ({ theme }) => (
  <style>
    {`
      .custom-datepicker-wrapper {
        background: ${theme.palette.background.paper};
      }
      
      .react-datepicker {
        font-family: ${theme.typography.fontFamily};
        border: none;
        background-color: ${theme.palette.background.paper};
        box-shadow: none;
      }
      
      .react-datepicker__header {
        background-color: transparent;
        border-bottom: none;
        padding-bottom: 8px;
        font-weight: 500;
        }
      
      .react-datepicker__current-month,
      .react-datepicker__day-name {
        color: ${theme.palette.text.primary};
        font-weight: 500;
        font-size: 15px;
        margin: 8px 0;
      }
      
      .react-datepicker__current-month {
        display: none;
      }
      
      .react-datepicker__year-option--selected {
        display: none; 
      }
      
      .react-datepicker__month-option--selected {
        display: none; 
      }
      
      .react-datepicker__day-name {
        width: 2.5rem;
        line-height: 2.5rem;
        margin: 2px;
      }

      .react-datepicker__day {
        color: ${theme.palette.text.primary};
        border-radius: 8px;
        transition: all 0.2s;
        width: 2.5rem;
        height: 2.5rem;
        line-height: 2.5rem;
        margin: 2px;
        font-size: 14px;
      }
      
      .react-datepicker__day:hover {
      color: ${theme.palette.primary.contrastText};
        background-color: ${theme.palette.action.hover};
        border-radius: 8px;
      }
      
      .react-datepicker__day--selected,
      .react-datepicker__day--in-range,
      .react-datepicker__day--in-selecting-range {
        background-color: ${theme.palette.primary.main};
        color: ${theme.palette.primary.contrastText};
        border-radius: 8px;
      }
      
      .react-datepicker__day--range-start,
      .react-datepicker__day--range-end {
        background-color: ${theme.palette.primary.main};
        color: ${theme.palette.primary.contrastText};
        border-radius: 8px;
      }
      
      .react-datepicker__day--keyboard-selected {
        background-color: ${theme.palette.action.selected};
        color: ${theme.palette.text.primary};
      }
      
      .react-datepicker__day--disabled {
        color: ${theme.palette.text.disabled};
        cursor: not-allowed;
      }
      
      .react-datepicker__day--outside-month {
        visibility: hidden;
      }
      
      .react-datepicker__navigation {
        top: 20px;
      }
      
      .react-datepicker__navigation-icon::before {
        border-color: ${theme.palette.text.primary};
      }
      
      .react-datepicker__month-container {
        padding: 12px;
      }
      
      .react-datepicker__week {
        display: flex;
        justify-content: space-around;
      }
      
      /* Month and Year Dropdowns */
      .react-datepicker__month-dropdown-container {
        margin: 0 16px 0 8px;
      }
      
      .react-datepicker__year-dropdown-container {
        margin: 0 8px;
      }
      
      .react-datepicker__month-read-view,
      .react-datepicker__year-read-view {
        font-size: 16px;
        padding: 6px 4px;
        font-weight: 600;
        background-color: transparent;
        visibility: visible !important;
        color: ${theme.palette.text.primary};
      }
      
      .react-datepicker__month-read-view--selected-month,
      .react-datepicker__year-read-view--selected-year {
        visibility: visible !important;
      }

      .react-datepicker__month-dropdown,
      .react-datepicker__year-dropdown {
        background-color: ${theme.palette.background.paper};
        border: 1px solid ${theme.palette.divider};
        border-radius: 8px;
        box-shadow: ${theme.shadows[8]};
        max-height: 300px;
        overflow-y: auto;
        margin-top: 4px;
      }
      
      .react-datepicker__month-option,
      .react-datepicker__year-option {
        padding: 8px 16px;
        color: ${theme.palette.text.primary};
        cursor: pointer;
        transition: background-color 0.2s;
        background-color: transparent;
      }
      
      .react-datepicker__month-option:hover,
      .react-datepicker__year-option:hover {
        background-color: ${theme.palette.action.hover};
      }
      
      .react-datepicker__month-option--selected,
      .react-datepicker__year-option--selected {
        background-color: ${theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[200]};
        color: ${theme.palette.text.primary};
        padding-left: 16px !important;
      }
      
      .react-datepicker__month-option--selected:hover,
      .react-datepicker__year-option--selected:hover {
        background-color: ${theme.palette.mode === 'dark' ? theme.palette.grey[600] : theme.palette.grey[300]};
      }
      
      /* Hide the checkmark by removing its space */
      .react-datepicker__month-option--selected::before,
      .react-datepicker__year-option--selected::before {
        content: '' !important;
      }
      
      /* Scrollbar styling for dropdowns */
      .react-datepicker__month-dropdown::-webkit-scrollbar,
      .react-datepicker__year-dropdown::-webkit-scrollbar {
        width: 8px;
      }
    
      
      .react-datepicker__month-dropdown::-webkit-scrollbar-track,
      .react-datepicker__year-dropdown::-webkit-scrollbar-track {
        background: ${theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[100]};
        border-radius: 4px;
      }
      
      .react-datepicker__month-dropdown::-webkit-scrollbar-thumb,
      .react-datepicker__year-dropdown::-webkit-scrollbar-thumb {
        background: ${theme.palette.mode === 'dark' ? theme.palette.grey[600] : theme.palette.grey[400]};
        border-radius: 4px;
      }
      
      .react-datepicker__month-dropdown::-webkit-scrollbar-thumb:hover,
      .react-datepicker__year-dropdown::-webkit-scrollbar-thumb:hover {
        background: ${theme.palette.mode === 'dark' ? theme.palette.grey[500] : theme.palette.grey[500]};
      }
    `}
  </style>
);
